import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('manage-cuti/index', {params});
    },
    updateKuota(id_karyawan, params) {
        return Service().post('manage-cuti/update-kuota/'+id_karyawan, params);
    },
}
